export default[
    {
        path: '/boletins/tabela/trabalhadores/cadastro/:id/:tomador_id',
        name: 'cadastro de trabalhadores', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/boletins/tabela/trabalhadores/lista/:id/:tomador_id',
        name: 'lista de trabalhadores', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/boletins/tabela/trabalhadores/editar/:boletim/:id/:tomador_id',
        name: 'editar trabalhadores', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]
